export interface AuthState {
  username?: string;
  token?: string;
  tokenExpiresAt?: Date;
  refreshToken?: string;
  refreshInProgress?: boolean;
}

export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const SET_REFRESH_IN_PROGRESS = 'SET_REFRESH_IN_PROGRESS';

interface LoggedInAction {
  type: typeof LOGGED_IN;
  token: string;
  refreshToken: string;
}

interface LoggedOutAction {
  type: typeof LOGGED_OUT;
  username: string;
}

interface SetRefreshInProgressAction {
  type: typeof SET_REFRESH_IN_PROGRESS;
  refreshInProgress: boolean;
}

export type AuthActionTypes =
  | LoggedInAction
  | LoggedOutAction
  | SetRefreshInProgressAction;
